const mapping: Record<string, string> = {
  id: 'ds=>ds.Id',
  name: 'ds=>ds.Name',
}

export const mapSortDynamicStatisticsParam = (key: string) => mapping[key]
